import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppLayout from "@/components/AppLayout";
import CommandPalette from "@/components/CommandPalette";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import NetworkPage from "@/pages/NetworkPage";
import AgentProfilePage from "@/pages/AgentProfilePage";
import FeedPage from "@/pages/FeedPage";
import ProfilePage from "@/pages/ProfilePage";
import MessagesPage from "@/pages/MessagesPage";
import ReferralsPage from "@/pages/ReferralsPage";
import PublicPropertyPage from "@/pages/PublicPropertyPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function Protected() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-900 text-zinc-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return (
    <AppLayout>
      <CommandPalette />
      <Outlet />
    </AppLayout>
  );
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/signup" element={<PublicOnly><SignupPage /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPasswordPage /></PublicOnly>} />
            <Route path="/p/:id" element={<PublicPropertyPage />} />
            <Route element={<Protected />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/network" element={<NetworkPage />} />
              <Route path="/feed" element={<FeedPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/messages/:agentId" element={<MessagesPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/agents/:id" element={<AgentProfilePage />} />
              <Route path="/referrals" element={<ReferralsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster
            theme="dark"
            toastOptions={{
              style: {
                background: "#121216",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#F8F9FA",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
